import React from 'react';
import { PageTitle } from '@cordata/buffet';

import Form from '~/components/User/Form';

const UsersAdd = () => (
  <>
    <PageTitle>Add User</PageTitle>

    <Form canEdit />
  </>
);

export default UsersAdd;
